import { StateCreator } from 'zustand';

export type GeneralSliceType = {
    lastVisitedSlug: string | null;
    lastVisitedProductsCatNumbers: string[];

    updateLastVisitedSlug: (value: string) => void;
    updateGeneralState: (value: Partial<GeneralSliceType>) => void;
};

export const createGeneralSlice: StateCreator<GeneralSliceType> = (set) => ({
    lastVisitedSlug: null,
    lastVisitedProductsCatNumbers: [],

    updateGeneralState: (value) => {
        set(value);
    },
    updateLastVisitedSlug: (value) => {
        set({ lastVisitedSlug: value });
    },
});
